/**
 * Central runtime config — the only place env vars are read.
 *
 * Same-origin defaults so ONE build works across every environment (the edge
 * nginx serves this SPA and proxies `/api` and `/ws`). The browser resolves the
 * relative base against the page's own origin, so no host is ever baked in.
 * Override with `REACT_APP_*` only if the API/WS ever live on a different host.
 */

// Per-environment values from /config.js, written at container start.
// `||` not `??`: unset vars arrive as "" and must fall through.
const runtime = window.__APP_CONFIG__ || {};

function wsFromLocation(path = '/ws') {
  const { protocol, host } = window.location;
  const scheme = protocol === 'https:' ? 'wss' : 'ws';
  return `${scheme}://${host}${path}`;
}

// Both API/WS overrides are dormant while the API stays same-origin:
//   runtime.*        — per-container, changeable without rebuilding.
//   process.env.*    — baked at build time; only for an `npm start` pointed elsewhere.
export const appConfig = {
  // Empty base = origin-relative; callers already prefix `/api/v1/`.
  API_BASE_URL: runtime.apiUrl || process.env.REACT_APP_API_URL || '',
  WS_BASE_URL: runtime.wsUrl || process.env.REACT_APP_WS_URL || wsFromLocation(),
  // No default: unset means a broken sign-in button.
  GOOGLE_CLIENT_ID: runtime.googleClientId || process.env.REACT_APP_GOOGLE_CLIENT_ID,
  defaultTimeout: 5000,
};

export const CAMERA_STATUS_COLORS = {
  GREEN: '#12B76A',
  GOLD: '#FBC348',
  RED: '#FF5C5C',
  GREY: '#D0D5DD',
  BLACK: '#000000',
};
